import React from 'react';
import { getIn } from 'formik';
import Input from '@/components/shared/Input';
import FloatSelect from '@/components/shared/FloatSelect';
import {
  IMultiStepSignupValues,
  CANADIAN_PROVINCES,
  AGE_GROUPS,
} from './types';
import { UserRole } from '@/types';
import TermsAndConditionsModal from '@/components/shared/TermsAndConditionsModal';
import './MultiStepSignupStep3.scss';

const baseClass = 'MultiStepSignupStep3';

interface Props {
  userRole: UserRole;
  values: IMultiStepSignupValues;
  errors: any;
  touched: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  setFieldValue: (field: string, value: any) => void;
}

const MultiStepSignupStep3: React.FC<Props> = ({
                                                 userRole,
                                                 values,
                                                 errors,
                                                 touched,
                                                 handleChange,
                                                 handleBlur,
                                                 setFieldValue,
                                               }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [modalType, setModalType] = React.useState<'terms' | 'privacy'>('terms');

  const handleTermsClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setModalType('terms');
    setShowModal(true);
  };

  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setModalType('privacy');
    setShowModal(true);
  };

  const handleAccept = () => {
    setFieldValue('agreeToTerms', true);
    setShowModal(false);
  };

  return (
    <div className={baseClass}>
      <div className={`${baseClass}__header`}>
        <h2 className={`${baseClass}__title`}>Additional Information</h2>
      </div>

      <div className={`${baseClass}__form-group`}>
        {/* Province / Territory */}
        <div className={`${baseClass}__field`}>
          <FloatSelect
            value={values.province}
            floatLabel={true}
            onChange={(e) => setFieldValue('province', e.target.value)}
            onBlur={handleBlur}
            name="province"
            label="Province / Territory"
            options={CANADIAN_PROVINCES}
            errors={
              getIn(errors, 'province') && getIn(touched, 'province')
                ? getIn(errors, 'province')
                : ''
            }
          />
        </div>

        {/* Phone Number */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.phone}
          name="phone"
          type="tel"
          label="Phone number"
          placeholder="(___) ___-____"
          errors={
            getIn(errors, 'phone') && getIn(touched, 'phone')
              ? getIn(errors, 'phone')
              : ''
          }
        />

        {/* Age Group */}
        <div className={`${baseClass}__field`}>
          <FloatSelect
            value={values.ageGroup}
            floatLabel={true}
            onChange={(e) => setFieldValue('ageGroup', e.target.value)}
            onBlur={handleBlur}
            name="ageGroup"
            label="Age group"
            options={AGE_GROUPS}
            errors={
              getIn(errors, 'ageGroup') && getIn(touched, 'ageGroup')
                ? getIn(errors, 'ageGroup')
                : ''
            }
          />
        </div>

        {/* Terms and Conditions */}
        <div className={`${baseClass}__terms`}>
          <label className={`${baseClass}__terms-label`}>
            <input
              type="checkbox"
              name="agreeToTerms"
              checked={values.agreeToTerms}
              onChange={handleChange}
              className={`${baseClass}__terms-checkbox`}
            />
            <span className={`${baseClass}__terms-text`}>
              By creating an account you agree to the{' '}
              <a
                href="#"
                onClick={handleTermsClick}
                className={`${baseClass}__terms-link`}
              >
                Terms of Service
              </a>
              {' and '}
              <a
                href="#"
                onClick={handlePrivacyClick}
                className={`${baseClass}__terms-link`}
              >
                Privacy Policy
              </a>.
            </span>
          </label>
          {getIn(errors, 'agreeToTerms') && getIn(touched, 'agreeToTerms') && (
            <div className={`${baseClass}__field-error`}>
              {getIn(errors, 'agreeToTerms')}
            </div>
          )}
        </div>
      </div>
      <TermsAndConditionsModal
        isOpen={showModal}
        type={modalType}
        onClose={() => setShowModal(false)}
        onAccept={handleAccept}
      />
    </div>
  );
};

export default MultiStepSignupStep3;
